// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Big from "../../util/lib/bindings/Big.js";
import * as Buhta_models__Protocol_v1_bs from "../../models/generated/Protocol_v1_bs.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";

Big.setDP(4);

Big.setRM(1);

const defaultCfg = {
  app_url: "",
  idp_url: "",
  cabinet_url: "",
  grpc_url: "",
  cms_api_url: "",
  app_env: "local",
  ym_key: "",
  app_mode: "test"
};

const defaultState = {
  ctx: "user",
  serverUrl: undefined,
  user: undefined,
  prefetched: true,
  deviceType: "",
  payload: undefined
};

function getConfig(param) {
  return Belt__Belt_Option.getWithDefault(Caml_option.undefined_to_opt(typeof __CFG__ === "undefined" ? undefined : __CFG__), defaultCfg);
}

function getState(param) {
  return Belt__Belt_Option.mapWithDefault(Caml_option.undefined_to_opt(typeof __STATE__ === "undefined" ? undefined : __STATE__), defaultState, (function (serialized) {
                return Curry._1(Buhta_models__Protocol_v1_bs.read_app_state, serialized);
              }));
}

export {
  defaultCfg ,
  defaultState ,
  getConfig ,
  getState ,
}
/*  Not a pure module */
